import { render, staticRenderFns } from "./TooltipLabel.vue?vue&type=template&id=4edb1680&"
import script from "./TooltipLabel.vue?vue&type=script&lang=js&"
export * from "./TooltipLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports